export interface ReplicationNode {
    url?: string;
    database?: string;
    disabled?: boolean;
}
